var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTaniumIcon = function SvgTaniumIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.75.034a16 16 0 0 0-8.49 3.173C3.443 5.334 1.386 8.402.505 11.789a15.7 15.7 0 0 0-.19 7.082c1.188 5.892 5.688 10.618 11.551 12.13 1.408.362 2.881.53 4.326.494.663-.018 1.468-.078 1.766-.135l.104-.019V18.304H9.76V13.39H31.5v-.072c0-.117-.215-1.144-.333-1.582A15.8 15.8 0 0 0 28.41 6.16 15.9 15.9 0 0 0 19.821.504a16.5 16.5 0 0 0-5.07-.47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23.94 23.94c0 3.118.01 5.67.02 5.67.076 0 1.298-.864 1.767-1.251.714-.59 1.726-1.594 2.261-2.252a16.47 16.47 0 0 0 3.445-7.39c.039-.193.067-.375.067-.401 0-.04-.5-.046-3.78-.046h-3.78z"
  })));
};
export default SvgTaniumIcon;